interface CacheStorage {
    setItem(key: string, value: string): void;
    getItem(key: string): string | null;
    removeItem(key: string): void;
}

interface Cache {
    set(key: string, value: string): void;
    get(key: string): string | null;
    setJSON(key: string, jsonValue: any): void;
    getJSON(key: string): any;
    remove(key: string): void;
}

function createCache (storage: CacheStorage | null): Cache {
  const isAvailable = (): boolean => {
    try {
      return storage !== null && typeof storage.setItem === 'function'
    } catch {
      return false
    }
  }

  return {
    set (key: string, value: string): void {
      if (!isAvailable()) return
      if (key != null && value != null) {
                storage!.setItem(key, value)
      }
    },
    get (key: string): string | null {
      if (!isAvailable()) return null
      if (key == null) return null
      return storage!.getItem(key)
    },
    setJSON (key: string, jsonValue: any): void {
      if (jsonValue != null) {
        this.set(key, JSON.stringify(jsonValue))
      }
    },
    getJSON (key: string): any {
      const value = this.get(key)
      if (value != null) {
        return JSON.parse(value)
      }
      return null
    },
    remove (key: string): void {
      if (!isAvailable()) return
            storage!.removeItem(key)
    }
  }
}

const sessionCache: Cache = createCache(typeof sessionStorage !== 'undefined' ? sessionStorage : null)
const localCache: Cache = createCache(typeof localStorage !== 'undefined' ? localStorage : null)

export default {
  /**
     * 会话级缓存
     */
  session: sessionCache,
  /**
     * 本地缓存
     */
  local: localCache
}
